<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
              <div class="title">添加</div>
              <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">

                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">公司名称</div>
                        <el-input v-model="add_name" placeholder="请输入公司名称"></el-input>
                    </el-col>
                  <el-col :span="12" class="item">
                    <div class="label">联系人</div>
                    <el-input v-model="add_contacts" placeholder="请输入联系人"></el-input>
                  </el-col>
                </el-row>

                <el-row class="row">
                  <el-col :span="12" class="item">
                    <div class="label">电话(登录账号)</div>
                    <el-input v-model="add_phone" placeholder="请输入电话"></el-input>
                  </el-col>
                  <el-col :span="12" class="item">
                    <div class="label">登录密码</div>
                    <el-input v-model="add_password" placeholder="请输入密码"></el-input>
                  </el-col>
<!--                     <el-col :span="24" class="item">-->
<!--                          <div class="label">地址</div>-->
<!--                              <el-input v-model="add_address" disabled placeholder="请选择地址">-->
<!--                                  <el-button slot="append" icon="el-icon-search" @click="openBaiduMap">-->
<!--                                      选择-->
<!--                                  </el-button>-->
<!--                              </el-input>-->
<!--                      </el-col>-->
                </el-row>

              <el-row class="row">
                <el-col :span="12" class="item">
                  <div class="label">地址</div>
                  <el-input v-model="add_address" placeholder="请输入公司地址"></el-input>
                </el-col>
              </el-row>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click.native="confirm">确认</el-button>
            </div>
        </div>

      <BaiduMap ref="baiduMap" v-show="baiduMapShow" v-on:colseMap="baiduMapShow = false" v-on:setMap="setMap"></BaiduMap>

    </div>
</template>


<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import BaiduMap from "./Map";

    export default {
        name: 'Add',
        props: ['roleValue'],
        data() {
            return {

                baiduMapShow: false,
                loading: false,

                add_name:'',
                add_phone:'',
                add_contacts:'',
                add_address:'',
              add_password:'',

            }
        },
        components: {
            BaiduMap
        },
        methods: {
            init(){

                this.add_name = '';
                this.add_phone = '';
                this.add_contacts = '';
                this.add_address = '';
                this.add_password = '';

            },

            closeSelf() {
                this.$emit("closeAdd");
            },

          openBaiduMap() {
                this.$refs.baiduMap.init('合肥');
                this.baiduMapShow = true;
            },
            setMap(info) {
                this.add_address = info.addressInfo
                this.lon = info.lng
                this.lat = info.lat
                this.baiduMapShow = false
            },


            confirm(){

                if(this.add_name == ''){
                  this.$message.info("填写名称");
                  return;
                }
                if(this.add_phone == ''){
                  this.$message.info("填写手机号");
                  return;
                }
                if(this.add_contacts == ''){
                  this.$message.info("填写联系人");
                  return;
                }
                if(this.add_address == ''){
                  this.$message.info("填写地址");
                  return;
                }

              if(this.add_password == ''){
                this.$message.info("填写密码");
                return;
              }
              if(this.add_password.length<6 || this.add_password.length>20){
                this.$message.info("密码长度为6至20位");
                return;
              }


              if(this.loading){
                return;
              }else{
                this.loading = true;
              }

              this.$axios({
                  method: 'post',
                  url: this.$shopUrl+'Government/AddByAdmin',
                  data: {
                      timeStr:timeStr,
                      sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                      staffCode: getStaffCode(),

                      name: this.add_name,
                      phone:this.add_phone,
                      contacts:this.add_contacts,
                      address:this.add_address,
                      password:this.add_password,
                  }
              }).then( (response)=> {
                  //console.log(response.data);
                  this.loading = false;

                  if(response.data.error == 0){
                      this.$emit("closeAdd");
                      this.$emit("getList");
                  }else if(response.data.error == 1){
                      this.$message(response.data.message);
                  }else{
                      console.log(response.data.message);
                  }

              }).catch(function (error) {
                  console.log(error);
              });

            },


        }
    }
</script>


<style  lang="scss" scoped>

</style>
